import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Button } from '../../../components/button'
import { useParams, Link } from "react-router-dom";
import PaymentProcessorForm from '../../../components/forms/payment-processor-form';
import { getPaymentProcessorDetail } from '../../../slices/paymentprocessors';

const PaymentProcessorCreate = () => {
    return (
        <>
            <div className="container-fluid">
                <div className="row clamped">
                    <div className="col px-0 settings-header flex-wrap">
                        <h1 className="title">{gettext("New Payment Processor")}</h1>
                        <Link to={"/settings/paymentprocessors"}><Button variant={"secondary"} size={"sm"}>{gettext('Cancel')}</Button></Link>
                    </div>
                </div>
            </div>
            <PaymentProcessorForm />
        </>
    )
}

export default PaymentProcessorCreate